import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { Multiselect } from "multiselect-react-dropdown";
import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";
import {
  getshipNameList,
  getUserDetails,
  getUsersList,
} from "../Actions/UserManageAPI";
import "./UserManagementMaster.css";

const currentUser = JSON.parse(localStorage.getItem("currentUser"));

const authHeaders = () => ({
  headers: { key: currentUser?.accessToken },
});

const defaultSearchData = {
  Mail: "",
  PageNumber: 1,
  PageSize: 15,
};

class MMPLUserEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      saving: false,
      userInfo: {
        userId: 0,
        email: "",
        isAdmin: false,
        isGrandAdmin: false,
        isApprover: false,
        isDeleted: false,
        modifiedBy: currentUser?.name || "",
      },
      ships: [],
      fieldErrors: {
        email: "",
      },
    };
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleAdminChange = this.handleAdminChange.bind(this);
    this.handleApproverChange = this.handleApproverChange.bind(this);
    this.handleGrantAdminChange = this.handleGrantAdminChange.bind(this);
    this.onShipSelect = this.onShipSelect.bind(this);
    this.onShipRemove = this.onShipRemove.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  componentDidMount() {
    const { match, dispatch, t } = this.props;
    const userId = match.params.id;
    const isCreateMode = !userId;

    dispatch({
      type: "SubBannerTitle",
      data: (
        isCreateMode
          ? t("MMPLUserManagementContent.AddUser")
          : t("ClientManagementScreenContent.UpdateUser")
      ).toUpperCase(),
    });
    dispatch({ type: "ShowSidePan", data: false });
    dispatch(getshipNameList());

    if (!isCreateMode) {
      this.setState({ loading: true });
      dispatch(getUserDetails(userId));
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { UserDetails, dispatch, match } = nextProps;
    const userId = match?.params?.id;

    if (!userId || !UserDetails || UserDetails === "") {
      return null;
    }

    const ships = Array.isArray(UserDetails.mmplUserShips)
      ? UserDetails.mmplUserShips.map((ship) => ship.shipName).filter(Boolean)
      : [];

    dispatch({ type: "getUserDetailsSuccess", data: "" });

    return {
      loading: false,
      userInfo: {
        userId: UserDetails.userId || 0,
        email: UserDetails.emailId || "",
        isAdmin: !!UserDetails.isAdmin,
        isGrandAdmin: !!UserDetails.grandAdminAccess,
        isApprover: !!UserDetails.isApprover,
        isDeleted: false,
        modifiedBy: currentUser?.name || "",
      },
      ships,
    };
  }

  isCreateMode() {
    return !this.props.match.params.id;
  }

  handleEmailChange(e) {
    const { value } = e.target;
    this.setState((prevState) => ({
      userInfo: {
        ...prevState.userInfo,
        email: value,
      },
      fieldErrors: {
        ...prevState.fieldErrors,
        email: "",
      },
    }));
  }

  handleAdminChange(e) {
    const isAdmin = e.target.checked;
    this.setState((prevState) => ({
      userInfo: {
        ...prevState.userInfo,
        isAdmin,
        isApprover: isAdmin ? false : prevState.userInfo.isApprover,
        isGrandAdmin: isAdmin ? false : prevState.userInfo.isGrandAdmin,
      },
      ships: isAdmin ? [] : prevState.ships,
    }));
  }

  handleApproverChange(e) {
    const isApprover = e.target.checked;
    this.setState((prevState) => ({
      userInfo: {
        ...prevState.userInfo,
        isApprover,
        isGrandAdmin: isApprover ? false : prevState.userInfo.isGrandAdmin,
      },
    }));
  }

  handleGrantAdminChange(e) {
    const isGrandAdmin = e.target.checked;
    this.setState((prevState) => ({
      userInfo: {
        ...prevState.userInfo,
        isGrandAdmin,
        isApprover: isGrandAdmin ? false : prevState.userInfo.isApprover,
      },
    }));
  }

  onShipSelect(selectedList) {
    this.setState({ ships: selectedList });
  }

  onShipRemove(selectedList) {
    this.setState({ ships: selectedList });
  }

  isValidEmail(email) {
    const pattern =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return pattern.test((email || "").trim());
  }

  validateForm(t) {
    const { userInfo } = this.state;
    const fieldErrors = { email: "" };

    if (!(userInfo.email || "").trim()) {
      fieldErrors.email = t("MMPLUserManagementContent.Emailismandatory");
    } else if (!this.isValidEmail(userInfo.email)) {
      fieldErrors.email = t("ErrorMessage.InvalidMsg");
    }

    this.setState({ fieldErrors });
    return !fieldErrors.email;
  }

  getSearchData() {
    const { userSearch } = this.props;
    return userSearch && typeof userSearch === "object"
      ? { ...userSearch }
      : { ...defaultSearchData };
  }

  handleCancel() {
    this.props.history.push("/Home/Management/Users/MMPL");
    window.scrollTo(0, 0);
  }

  createUser() {
    const { dispatch, t, history } = this.props;
    const { userInfo, ships } = this.state;

    this.setState({ saving: true });

    axios
      .get(
        `${API.userExist}?Mail=${encodeURIComponent(userInfo.email.trim())}`,
        authHeaders()
      )
      .then((existResponse) => {
        if (existResponse.data !== true) {
          this.setState({ saving: false });
          toast.warning(t("ShipManagementContent.UserWaringMsg"));
          return;
        }

        const payload = {
          email: userInfo.email.trim(),
          isAdmin: userInfo.isAdmin,
          grandAdminAccess: userInfo.isGrandAdmin,
          isApprover: userInfo.isApprover,
          mmplShips: userInfo.isAdmin ? "" : ships.join(","),
          createdBy: currentUser?.name || "",
        };

        axios
          .post(API.UserAPI, payload, authHeaders())
          .then((response) => {
            this.setState({ saving: false });
            if (response.data === "User Add Failed") {
              toast.error(t("CommonText.500ErrorMessage"));
              return;
            }
            dispatch(getUsersList(this.getSearchData()));
            toast.success(t("CommonText.CommonAdd"));
            history.push("/Home/Management/Users/MMPL");
            window.scrollTo(0, 0);
          })
          .catch(() => {
            this.setState({ saving: false });
            toast.error(t("CommonText.500ErrorMessage"));
          });
      })
      .catch(() => {
        this.setState({ saving: false });
        toast.error(t("CommonText.500ErrorMessage"));
      });
  }

  updateUser() {
    const { dispatch, t, history } = this.props;
    const { userInfo, ships } = this.state;

    this.setState({ saving: true });

    const payload = {
      userId: userInfo.userId,
      email: userInfo.email.trim(),
      isAdmin: userInfo.isAdmin,
      grandAdminAccess: userInfo.isGrandAdmin,
      isApprover: userInfo.isApprover,
      isDeleted: false,
      mmplShips: userInfo.isAdmin ? "" : ships.join(","),
      modifiedBy: currentUser?.name || "",
    };

    axios
      .put(API.UserAPI, payload, authHeaders())
      .then((response) => {
        this.setState({ saving: false });
        if (response.data === "User details Update Failed") {
          toast.error(t("CommonText.500ErrorMessage"));
          return;
        }
        dispatch(getUsersList(this.getSearchData()));
        toast.success(t("CommonText.CommonUpdate"));
        history.push("/Home/Management/Users/MMPL");
        window.scrollTo(0, 0);
      })
      .catch(() => {
        this.setState({ saving: false });
        toast.error(t("CommonText.500ErrorMessage"));
      });
  }

  handleSave() {
    const { t } = this.props;
    if (!this.validateForm(t)) {
      return;
    }

    if (this.isCreateMode()) {
      this.createUser();
    } else {
      this.updateUser();
    }
  }

  renderEmailField(t) {
    const error = this.state.fieldErrors.email;

    return (
      <div className={`col-lg-4 col-md-6 col-12 um-filter-field um-mmpl-email-field${error ? " has-error" : ""}`}>
        <label className="form-label">
          {t("MMPLUserManagementContent.EmailId")}
          <span className="um-required">*</span>
        </label>
        <div className={`um-input-shell${error ? " is-invalid" : ""}`}>
          <span className="um-input-icon">
            <i className="fa fa-envelope-o" aria-hidden="true"></i>
          </span>
          <input
            className="form-control"
            type="email"
            name="email"
            placeholder={t("MMPLUserManagementContent.EmailId")}
            value={this.state.userInfo.email}
            onChange={this.handleEmailChange}
            aria-invalid={error ? "true" : "false"}
          />
        </div>
        {error ? (
          <div className="um-field-error" role="alert">
            <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
            <span>{error}</span>
          </div>
        ) : null}
      </div>
    );
  }

  renderSimpleCheckboxField(label, checked, onChange) {
    return (
      <div className="um-mmpl-checkbox-field">
        <label className="form-label um-mmpl-checkbox-label">
          <input type="checkbox" checked={checked} onChange={onChange} />
          <span>{label}</span>
        </label>
      </div>
    );
  }

  renderPermissionsFields(t, userInfo) {
    return (
      <div className="col-lg-auto col-md-12 col-12 um-filter-field um-mmpl-permissions-field">
        <label className="form-label um-mmpl-permissions-label">
          {t("MMPLUserManagementContent.AccessRights")}
        </label>
        <div className="um-mmpl-permissions-row">
          {this.renderSimpleCheckboxField(
            t("MMPLUserManagementContent.IsAdmin"),
            userInfo.isAdmin,
            this.handleAdminChange
          )}
          {!userInfo.isAdmin ? (
            <>
              {this.renderSimpleCheckboxField(
                t("MMPLUserManagementContent.IsApprover"),
                userInfo.isApprover,
                this.handleApproverChange
              )}
              {this.renderSimpleCheckboxField(
                t("MMPLUserManagementContent.IsGrantAdmin"),
                userInfo.isGrandAdmin,
                this.handleGrantAdminChange
              )}
            </>
          ) : null}
        </div>
      </div>
    );
  }

  renderShipField(t) {
    const { shipNameList } = this.props;
    const { ships } = this.state;

    return (
      <div className="col-lg col-md-12 col-12 um-filter-field um-ship-field">
        <label className="form-label">{t("content.Shipname")}</label>
        <div className="um-multiselect-shell">
          <span className="um-input-icon um-multiselect-icon">
            <i className="fa fa-ship" aria-hidden="true"></i>
          </span>
          <div className="um-multiselect-control">
            <Multiselect
            options={shipNameList || []}
            isObject={false}
            selectedValues={ships}
            onSelect={this.onShipSelect}
            onRemove={this.onShipRemove}
            showArrow={false}
            avoidHighlightFirstOption
            placeholder={ships.length ? "" : "Select ships"}
            closeIcon="cancel"
            style={{
              multiselectContainer: { width: "100%" },
              chips: { background: "#1a3464" },
              option: {
                color: "#0f172a",
                backgroundColor: "#ffffff",
              },
              highlightOption: {
                backgroundColor: "#eef3fa",
                color: "#1a3464",
              },
            }}
          />
          </div>
          <span className="um-multiselect-chevron" aria-hidden="true">
            <i className="fa fa-chevron-down"></i>
          </span>
        </div>
      </div>
    );
  }

  render() {
    const { t } = this.props;
    const { loading, saving, userInfo } = this.state;
    const isCreateMode = this.isCreateMode();

    if (loading) {
      return (
        <div className="full-height user-module-master um-edit-page um-mmpl-edit">
          <div className="um-empty-state pt-5">Loading...</div>
        </div>
      );
    }

    return (
      <div className="full-height user-module-master um-edit-page um-mmpl-edit">
        <div className="pt-3">
          <button
            type="button"
            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue um-return-btn"
            onClick={this.handleCancel}
          >
            <span>&larr;</span>
            {t("CommonText.Return")}
          </button>

          <div className="um-section">
            <div className="um-section-header">
              <h5 className="um-section-title">
                <i className="fa fa-user um-section-title-icon" aria-hidden="true"></i>
                {isCreateMode
                  ? t("MMPLUserManagementContent.AddUser")
                  : t("ClientManagementScreenContent.UpdateUser")}
              </h5>
            </div>
            <div className="um-section-body">
              <div className="row um-form-grid um-mmpl-form-row align-items-start">
                {this.renderEmailField(t)}
                {this.renderPermissionsFields(t, userInfo)}
                {!userInfo.isAdmin ? this.renderShipField(t) : null}
              </div>

              <div className={`um-form-actions um-section-footer${saving ? " is-saving" : ""}`}>
                <button
                  type="button"
                  className="btn btn-primary text-uppercase um-btn um-btn-primary"
                  onClick={this.handleSave}
                  disabled={saving}
                >
                  {isCreateMode
                    ? t("ComplianceandBudgetScreen.Submit")
                    : t("EquipmentServiceTypes.Update")}
                </button>
                <button
                  type="button"
                  className="btn btn-light text-uppercase um-btn um-btn-secondary"
                  onClick={this.handleCancel}
                  disabled={saving}
                >
                  {t("ComplianceandBudgetScreen.Cancel")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    UserDetails: state.UserManagerReducer.UserDetails,
    shipNameList: state.UserManagerReducer.shipNameList,
    userSearch: state.UserManagerReducer.userSearch,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(MMPLUserEdit))
);
